module.exports = require("@material-ui/core/Snackbar");